import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { NavLink } from 'react-router';

function TopBar({ siteMeta }: { siteMeta: SiteMeta }) {
  return (
    <div className='topbar'>
      <div className='frame'>
        {siteMeta.ui.TabsList?.PV?.map((configuredTab) => (
          <NavLink
            data-test={`nav-sun-${configuredTab.toLowerCase()}`}
            key={`nav-sun-${configuredTab.toLowerCase()}`}
            to={`/sun/${configuredTab.toLowerCase()}`}
            className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
          >
            <FormattedAlias
              id={configuredTab.toUpperCase().replace(/_/g, ' ')}
            />
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default storeConnector(TopBar, {
  config: ['siteMeta'],
});
